export enum FontSize {
  Small = 0,
  Medium = 1,
  Large = 2
}

export class FontSizeDefinition {
  static defaultClass(fontSize: FontSize): string {
    switch (fontSize) {
      case FontSize.Large:
        return 'lg';
      case FontSize.Medium:
        return 'md';
      case FontSize.Small:
        return 'sm';
      default:
        return ''
    }
  }
}